import axiosInstance from "./axiosInstance";

export const createCamera = (params) => {
  return axiosInstance.post(`camera/add`, params);
};

export const getCameraData = (id) => {
  return axiosInstance.get(`camera/${id}`);
};
